import Tasks from 'APP/Tasks';
import { addMessageReaction as addMessageReactionModel } from 'APP/model/message/messageModel';
import { IUpdateMessageReaction } from 'APP/model/message/messageModel.types';

export const addMessageReaction = async (data: IUpdateMessageReaction): Promise<void> => {
  try {
    const message = await addMessageReactionModel(data);
    Tasks.messaging.updateOldOrFakeMessages({
      messages: [message],
      groupId: message.groupId,
    });
  } catch (error) {
    // do nothing
  }
};
